import { Col, Row, Radio } from 'antd';
import React, { Component } from 'react';
import { BoxInput, BoxForm, BoxRadios, TitleSection, Label } from '../style';
import { LinhasDeCuidadoFormularioValidation } from '../validation/linhasDeCuidadoFormularioValidation';
import customChangeService from '../customChange/customChangeService';
/*
    Classe responsavel por montar o formulario e seus componentes
*/
export class LinhasDeCuidadoFormularioBuilder extends Component {
  _groups = []; // ref
  constructor(props) {
    super();
    let obj = {};
    let fields = {};
    this.fieldsRef = {};
    this.careLine = props.careLine;
    props.items.forEach(g => {
      g.fields.forEach(f => {
        let obj = {};
        obj[f.field] = null;
        fields[f.field] = f;
        this.fieldsRef[f.field] = React.createRef();
      });
    });
    this.state = obj;
    this.validation = new LinhasDeCuidadoFormularioValidation();
    this.validation.setFields(fields);
    this.notFound = [];
    this.exceptionVariable = [];
  }

  beforeunload(e) {
    if (window.location.pathname.includes('formulario-linha-de-cuidado')) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  async componentDidMount() {
    this.verifyGroupListEmpty();
    customChangeService(this.fieldsRef, this.careLine);
  }

  async componentDidUpdate() {
    this.verifyGroupListEmpty();
    window.addEventListener('beforeunload', this.beforeunload.bind(this));
  }

  inputChangeHandler = event => {
    let key = event.target.name;
    let val = event.target.value;
    let obj = {};
    obj[key] = val;
    let v = this.validation.validFormat(key, val);
    if (v.isValid) {
      this.setState(obj);
    } else {
      event.target.value = null;
    }
  };

  verifyGroupListEmpty = () => {
    // NOTE: para resolver os grupos e subgroups que não possuem nenhum campo a mostra
    this.props.items.forEach((e, idx) => {
      //TODO: criar class hide
      if (this._groups[idx].getElementsByClassName('item').length == 0) {
        this._groups[idx].style.display = 'none';
      } else {
        this._groups[idx].style.display = 'block';
      }
      //TODO: criar class hide subgroup
      let arr = this._groups[idx].getElementsByClassName('subGroup');
      if (arr.length > 0) {
        for (let s of arr) {
          if (s.getElementsByClassName('item').length == 0) {
            s.style.display = 'none';
          } else {
            s.style.display = 'block';
          }
        }
      }
    });
  };

  //#region stateForUpdate
  /*
   *  @description Funcao que recebe objeto do backend para adicionar no state do formulario (edicao de registro), tambem faz
   *  uma validacao dos campos que veem com 99/99/9999 pois o mesmo deve dar um checked nas checkbox de dado faltante
   *  @params Objecto do backend com dados do registro
   */
  setStateForUpdate = _update => {
    this.setState(_update);
    //NOTE: Problema com os campos que possui checkbox para preenchimento de dado faltante
    Object.keys(this.validation.fields).forEach(x => {
      if (this.validation.notFound.indexOf(String(_update[x])) >= 0) {
        //this.validation.fields[x]?.subGroup == ''
        this.changeNotFoundAndExeption(x, false, 'notFound');
      }
      /*if (
        this.validation.notFound.indexOf(_update[x]) >= 0 &&
        this.validation.fields[x]?.subGroup != ''
      ) {
        if (!this.notFoundCheck(this.validation.fields[x]?.subGroup)) {
          this.changeNotFoundAndExeption(
            this.validation.fields[x]?.subGroup,
            true,
            'notFound'
          );
        }
      }*/

      if (
        this.validation.exceptions.indexOf(String(_update[x])) >= 0 &&
        this.validation.fields[x]?.subGroup == ''
      ) {
        this.changeNotFoundAndExeption(x, false, 'exceptionVariable');
      }

      if (
        this.validation.exceptions.indexOf(_update[x]) >= 0 &&
        this.validation.fields[x]?.subGroup != ''
      ) {
        if (!this.exceptionVariableCheck(this.validation.fields[x]?.subGroup)) {
          this.changeNotFoundAndExeption(
            this.validation.fields[x]?.subGroup,
            true,
            'exceptionVariable'
          );
        }
      }
    });
  };
  //#endregion stateForUpdate

  //#region branchvalidation
  /*
   *  @description Funcao para verificacao de logia de ramificacao
   *  @params Campo com os dados do branchOption (objeto do backend)
   */
  checkBranchValidation = field => {
    if (field.branchOption == null || field.branchOption?.length == 0) {
      return true;
    } else {
      let aux = true;
      let branch = field.branchOption;
      if (branch.type == 'showIf') {
        if (!branch.values.includes(parseInt(this.state[branch.field]))) {
          //TODO: ver necessidade de ser so inteiro (tirar parseInt)
          aux = false;
        }
      }
      //{type: 'fieldRequired', fields:['pas_infusao_sepse', 'pad_infusao_sepse']
      if (branch.type == 'fieldRequired') {
        if (branch.fields.length > 0) {
          for (let idx of branch.fields) {
            if (
              !this.state[idx] ||
              this.state[idx] == null ||
              this.state[idx] == ''
            )
              aux = false;
          }
        }
      }
      if (!aux) this.state[field.field] = '';
      return aux;
    }
  };
  //#endregion branchvalidation

  //#region notfound checkbox
  /*
   *  @description Funcao que retorna caso exista checkbox marcada
   *  @params Campos que tem checkbox marcada, nome do campo ou nome do subgrupo marcado
   */
  notFoundCheck = field => {
    return this.notFound.indexOf(field) < 0 ? false : true;
  };

  exceptionVariableCheck = field => {
    return this.exceptionVariable.indexOf(field) < 0 ? false : true;
  };

  /*
   *  @description Funcao que check e atualiza campos com 99/99/9999 quando apenas 1 campo ele atualiza o campo quando passado o group true, ele verifica no
   *  parametro field quais campos tem esse field passado (subGroup)
   *  @params Campo correpondente ou subGroupo correspondente , flag de identificacao que e um grupo
   */
  changeNotFoundAndExeption = (field, group, type) => {
    let obj = {};
    const mask = {
      date: { exceptionVariable: '98/98/9998', notFound: '99/99/9999' },
      time: { exceptionVariable: '98:98', notFound: '99:99' },
      number: { exceptionVariable: '98', notFound: '99' },
    };
    let idx =
      type == 'notFound'
        ? this.notFound.indexOf(field)
        : this.exceptionVariable.indexOf(field);
    //console.log(idx);
    if (idx >= 0) {
      if (type == 'notFound') this.notFound.splice(idx, 1);
      else this.exceptionVariable.splice(idx, 1);
      obj[field] = '';
      if (group && type != 'notFound') {
        Object.keys(this.validation.fields)
          .filter(key => this.validation.fields[key].subGroup == field)
          .forEach(x => this.changeNotFoundAndExeption(x, false, type));
      }
    } else {
      if (type == 'notFound') this.notFound.push(field);
      else this.exceptionVariable.push(field);

      if (group && type != 'notFound') {
        Object.keys(this.validation.fields)
          .filter(key => this.validation.fields[key].subGroup == field)
          .forEach(x => this.changeNotFoundAndExeption(x, false, type));
        return;
      } else {
        let _field = this.validation.fields[field];
        if (typeof _field != 'undefined' && _field[type] == true) {
          obj[field] =
            typeof mask[_field.type][type] != 'undefined'
              ? mask[_field.type][type]
              : obj[field];
          if (_field.type == 'number' && type == 'notFound') {
            let calc = field => {
              let size = field?.size ? field.size : 1;
              let r = '';
              for (let i = 0; i < size; i++) {
                r += '9';
              }
              return r;
            };
            obj[field] = calc(_field);
          }
        }
      }
    }
    this.setState(obj);
    if (this.fieldsRef[field]?.current) {
      this.fieldsRef[field].current.value = obj[field];
    }
  };

  /**
   *
   * FOR GROUP EGC
   *
   */
  changeEcgExeption = (field, group, type) => {
    let obj = {};
    const mask = {
      date: { exceptionVariable: '98/98/9998', notFound: '99/99/9999' },
      time: { exceptionVariable: '98:98', notFound: '99:99' },
      number: { exceptionVariable: '98', notFound: '99' },
    };
    let idx = this.exceptionVariable.indexOf(field);

    if (idx >= 0) {
      // console.log('idx', idx);
      this.exceptionVariable.splice(idx, 1);

      obj[field] = '';
    } else {
      this.exceptionVariable.push(field);

      let _field = this.validation.fields[field];
      if (typeof _field != 'undefined' && _field[type] == true) {
        obj[field] =
          typeof mask[_field.type][type] != 'undefined'
            ? mask[_field.type][type]
            : obj[field];
        if (_field.type == 'number' && type == 'notFound') {
          let calc = field => {
            let size = field?.size ? field.size : 1;
            let r = '';
            for (let i = 0; i < size; i++) {
              r += '9';
            }
            return r;
          };
          obj[field] = calc(_field);
        }
      }
    }

    this.setState(obj);
    if (this.fieldsRef[field]?.current) {
      this.fieldsRef[field].current.value = obj[field];
    }
  };

  /**
   *
   * ./ FOR GROUP EGC
   *
   */

  changeFeSCaExeption = (field, type) => {
    this.fieldsRef[field].current.value = '';
    if (!this.state.fe_sca) {
      this.setState({
        fe_sca: type === 'notFound' ? '999' : '0',
      });
      this.fieldsRef[field].current.value = type === 'notFound' ? '999' : '0';
    } else {
      this.setState({
        fe_sca: '',
      });
      this.fieldsRef[field].current.value = '';
    }
  };

  formatMask(mask, event) {
    let value = event.target.value;
    let key = event.which || event.keyCode || event.charCode;
    if (key !== 8) {
      if (value) {
        let s = '' + value,
          r = '';
        for (let im = 0, is = 0; im < mask.length && is < s.length; im++) {
          if (mask[im] == '9') {
            if (this.validation.isNumber(s[is])) {
              r += s[is];
            }
          } else if (mask[im] == 'X') {
            r += s[is];
          } else {
            r += mask[im];
            if (mask[im] != s[is]) r += s[is];
          }
          is++;
        }
        event.target.value = r;
      }
    }
  }

  //#endregion notfound checkbox

  //#region render do componente
  /*
   *  @description Renderiza cada item passado ou de um grupo ou de um subgrupo
   *  @params Campo(el), flag se esta vindo de um subgropo
   */
  createField(el, group) {
    // console.log('el', el);

    return (
      <Col span={!group ? el.witdh * 12 : 24} className="item">
        <BoxInput>
          <Label className="w-100" style={{ display: 'flex' }}>
            {el.description}{' '}
            {el.notFound == true &&
            el.field !== 'fe_sca' && ( // && !group
                <>
                  <label
                    className="checkboxException"
                    style={{
                      display: 'flex',
                      marginLeft: '5px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="checkbox"
                      name={'not_found_' + el.field}
                      disabled={
                        this.exceptionVariableCheck(el.field) ||
                        (el.field === 'fe_sca' && this.state.fe_sca === '0')
                      }
                      checked={this.notFound.indexOf(el.field) >= 0} //TODO: n consegui usar a funcao notFoundCheck n efetua o checked
                      onChange={() =>
                        this.changeNotFoundAndExeption(
                          el.field,
                          group,
                          'notFound'
                        )
                      }
                    />
                    <div className="item-name" style={{ paddingLeft: '5px' }}>
                      Dado faltante
                    </div>
                  </label>
                </>
              )}
            {/* 
               fe_sca
             */}
            {el.notFound == true &&
            el.field === 'fe_sca' && ( // && !group
                <>
                  <label
                    className="checkboxException"
                    style={{
                      display: 'flex',
                      marginLeft: '5px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="checkbox"
                      name={'not_found_' + el.field}
                      disabled={
                        this.exceptionVariableCheck(el.field) ||
                        (el.field === 'fe_sca' && this.state.fe_sca === '0')
                      }
                      checked={this.state?.fe_sca === '999'}
                      onChange={() =>
                        this.changeFeSCaExeption(el.field, 'notFound')
                      }
                    />
                    <div className="item-name" style={{ paddingLeft: '5px' }}>
                      Dado faltante
                    </div>
                  </label>
                </>
              )}
            {el.field === 'fe_sca' && ( // && !group
              <>
                <label
                  className="checkboxException"
                  style={{
                    display: 'flex',
                    marginLeft: '5px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    alignItems: 'center',
                  }}
                >
                  <input
                    type="checkbox"
                    name={'not_found_' + el.field}
                    disabled={
                      this.exceptionVariableCheck(el.field) ||
                      (el.field === 'fe_sca' && this.state.fe_sca === '999')
                    }
                    checked={this.state?.fe_sca === '0'}
                    onChange={() =>
                      this.changeFeSCaExeption(el.field, 'unrealized')
                    }
                  />
                  <div className="item-name" style={{ paddingLeft: '5px' }}>
                    Não realizado
                  </div>
                </label>
              </>
            )}
            {el.exceptionVariable &&
            !group && ( //
                <>
                  <label
                    className="checkboxException"
                    style={{
                      display: 'flex',
                      marginLeft: '5px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="checkbox"
                      name={'exceptionVariable_' + el.field}
                      disabled={this.notFoundCheck(el.field)}
                      checked={this.exceptionVariable.indexOf(el.field) >= 0}
                      onChange={() =>
                        this.changeNotFoundAndExeption(
                          el.field,
                          group,
                          'exceptionVariable'
                        )
                      }
                    />
                    <div className="item-name" style={{ paddingLeft: '5px' }}>
                      {el.exceptionDescriptionVariable}
                    </div>
                  </label>
                </>
              )}
            {/*
              * 
              *
              *
              GROUP ECG
              *
              *
              *
              *
            */}
            {el.exceptionVariable &&
            el.subGroup === 'ecg' && ( //
                <>
                  <label
                    className="checkboxException"
                    style={{
                      display: 'flex',
                      marginLeft: '5px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      alignItems: 'center',
                    }}
                  >
                    <input
                      type="checkbox"
                      name={'exceptionVariable_' + el.field}
                      // disabled={this.notFoundCheck(el.field)}
                      checked={this.exceptionVariable.indexOf(el.field) >= 0} //TODO: n consegui usar a funcao notFoundCheck n efetua o checked
                      onChange={() =>
                        this.changeEcgExeption(
                          el.field,
                          group,
                          'exceptionVariable'
                        )
                      }
                    />
                    <div className="item-name" style={{ paddingLeft: '5px' }}>
                      {el.exceptionDescriptionVariable}
                    </div>
                  </label>
                </>
              )}
            {/*
              *
              GROUP ECG
              *
              *
            */}
          </Label>

          {el.type == 'number' && (
            <input
              name={el.field}
              id={el.field}
              maxLength={el.size}
              ref={this.fieldsRef[el.field]}
              pattern="[0-9]*"
              defaultValue={this.state[el.field]}
              onBlur={this.inputChangeHandler}
              disabled={
                this.notFoundCheck(el.field) ||
                this.exceptionVariableCheck(el.field)
              }
              placeholder={el.description}
              type="text"
            />
          )}

          {el.type == 'text' && (
            <input
              name={el.field}
              id={el.field}
              maxLength={el.size}
              ref={this.fieldsRef[el.field]}
              defaultValue={this.state[el.field]}
              onBlur={this.inputChangeHandler}
              disabled={this.notFoundCheck(el.field)}
              disabled={
                this.notFoundCheck(el.field) ||
                this.exceptionVariableCheck(el.field)
              }
              placeholder={el.description}
              type="text"
            />
          )}

          {el.type == 'date' && ( // TODO: Mask
            <input
              type="text"
              name={el.field}
              id={el.field}
              mask="99/99/9999"
              maxLength="10"
              onKeyUp={event => this.formatMask('99/99/9999', event)}
              disabled={
                this.notFoundCheck(el.field) ||
                this.exceptionVariableCheck(el.field)
              }
              defaultValue={this.state[el.field]}
              ref={this.fieldsRef[el.field]}
              placeholder={el.description}
              onBlur={this.inputChangeHandler}
            />
          )}

          {el.type == 'time' && ( // TODO: Mask
            <input
              type="text"
              name={el.field}
              id={el.field}
              mask="99:99"
              maxLength="5"
              disabled={
                this.notFoundCheck(el.field) ||
                this.exceptionVariableCheck(el.field)
              }
              defaultValue={this.state[el.field]}
              ref={this.fieldsRef[el.field]}
              placeholder={el.description}
              onKeyUp={event => this.formatMask('99:99', event)}
              onBlur={this.inputChangeHandler}
            />
          )}

          {el.type == 'float' && ( // TODO: Mask
            <input
              name={el.field}
              id={el.field}
              ref={this.fieldsRef[el.field]}
              pattern={el.pattern}
              defaultValue={this.state[el.field]}
              maxLength={el.size}
              onKeyUp={event => this.formatMask(el.mask, event)}
              onBlur={this.inputChangeHandler}
              disabled={
                this.notFoundCheck(el.field) ||
                this.exceptionVariableCheck(el.field)
              }
              placeholder={el.description}
              type="text"
            />
          )}

          {el.type == 'option' && (
            <>
              {el.options.map((op, idx2) => (
                <Col span={12} key={String(idx2)}>
                  <BoxRadios
                    active={this.state[el.field] == String(op.value)}
                    className="v-large"
                  >
                    <Radio
                      key={idx2}
                      name={el.field}
                      checked={this.state[el.field] == String(op.value)}
                      value={op.value}
                      defaultValue={this.state[el.field]}
                      ref={this.fieldsRef[el.field]}
                      onClick={this.inputChangeHandler}
                    >
                      <div className="item-name"> {op.description} </div>
                    </Radio>
                  </BoxRadios>
                </Col>
              ))}
            </>
          )}

          <div>
            {this.props.errors[el.field] != null && (
              <span className="invalid">{this.props.errors[el.field]}</span>
            )}
          </div>
        </BoxInput>
      </Col>
    );
  }

  /*
   *  @description Renderiza os subgroups (agrupamento geralmente de data e hora e multipla escolha)
   *  @params el subgrupo agrupando os itens que o compoeem
   */
  createFieldGroup(el) {
    return (
      <Col span={24} className="subGroup">
        <BoxInput className={el.field}>
          <h3 className="title" style={{ display: 'flex' }}>
            {el.name}
            {el.description}
            {el.exceptionVariable && el.field !== 'ecg' && (
              <>
                <label
                  className="checkboxException"
                  style={{
                    display: 'flex',
                    marginLeft: '5px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    alignItems: 'center',
                  }}
                >
                  <input
                    type="checkbox"
                    name={'exceptionVariable_' + el.field}
                    disabled={this.notFoundCheck(el.field)}
                    checked={this.exceptionVariable.indexOf(el.field) >= 0}
                    onChange={() =>
                      this.changeNotFoundAndExeption(
                        el.field,
                        true,
                        'exceptionVariable'
                      )
                    }
                  />
                  <div className="item-name" style={{ paddingLeft: '5px' }}>
                    {el.exceptionVariableDescription}
                  </div>
                </label>
              </>
            )}
          </h3>
          {el.items.map((el2, idx) => (
            <Col span={el2.witdh * 12} key={idx}>
              {this.checkBranchValidation(el2) == true && (
                <>{this.createField(el2, true)}</>
              )}
            </Col>
          ))}
        </BoxInput>
        <hr />
      </Col>
    );
  }

  /*
   *  @description Recebe os items de cada grupo de formulario, e reagrupa aqueles que sao um subgroup
   *  @params items do Grupo exemplo Items do Dados Gerais
   */
  createComponentsFields(items) {
    //TODO: verificar Validação
    let _items = [];
    items.forEach(r => {
      if (r.subGroup == '') {
        _items.push(r);
      } else {
        if (_items.findIndex(t => t.field == r.subGroup) < 0) {
          let _itemsGroup = items.filter(x => x.subGroup == r.subGroup);
          let notFoundGroup =
            _itemsGroup.filter(r => r.notFound == true).length > 0
              ? true
              : false;
          let exceptionVariable =
            _itemsGroup.filter(r => r.exceptionVariable == true).length > 0
              ? _itemsGroup.filter(r => r.exceptionVariable == true)[0]
              : false;
          //console.log(_itemsGroup)
          _items.push({
            field: r.subGroup,
            type: 'group',
            exceptionVariableDescription: exceptionVariable?.exceptionDescriptionVariable
              ? exceptionVariable.exceptionDescriptionVariable
              : '',
            exceptionVariable: exceptionVariable,
            notFoundGroup: notFoundGroup,
            name: r.subGroupDescription,
            items: _itemsGroup,
          });
        }
      }
    });

    return (
      <>
        <Row>
          {_items.map((el, idx) => (
            <Col key={idx}>
              {this.checkBranchValidation(el) == true && (
                <>
                  {el.type != 'group' && this.createField(el, false)}
                  {el.type == 'group' && this.createFieldGroup(el)}
                </>
              )}
            </Col>
          ))}
        </Row>
      </>
    );
  }

  /*
   *  @description Render do componente recebe todos os items vindo do backend, vem agrupados em grupos para montagem do formulario
   *  @params items do Grupo exemplo Items do Dados Gerais
   */
  render = () => {
    return (
      <>
        {this.props.items.map((el, idx) => (
          <BoxForm
            key={idx}
            ref={c => (this._groups[idx] = c)}
            className="groupClass"
          >
            <TitleSection>> {el.description}</TitleSection>
            {this.createComponentsFields(el.fields)}
            <hr />
          </BoxForm>
        ))}
      </>
    );
  };

  //#endregion render do componente
}
